export function assetUri(asset) {
  if (!asset) return '';
  if (typeof asset === 'string') return asset;
  if (typeof asset.uri === 'string') return asset.uri;
  if (asset.default) return assetUri(asset.default);
  return '';
}
